(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuva-cloud-gallery"] && !Shopify.designMode) return;
  try {
    
if (!window.nuvaGalleryReady) {
window.nuvaGalleryReady=true;
const setup=(root=document)=>{
root.querySelectorAll('.nuva-gallery').forEach(gallery=>{
if(gallery.dataset.initialized)return;
gallery.dataset.initialized='true';
const videos=[...gallery.querySelectorAll('video')];
const toggle=gallery.querySelector('[data-nuva-gallery-toggle]');
let paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let visible=false;
const sync=()=>{
toggle.textContent=paused?toggle.dataset.playLabel:toggle.dataset.pauseLabel;
toggle.setAttribute('aria-pressed',String(paused));
videos.forEach(video=>{video.muted=true;if(!paused&&visible&&!document.hidden)video.play().catch(()=>{});else video.pause();});
};
toggle.hidden=!videos.length;
toggle.addEventListener('click',()=>{paused=!paused;sync();});
if('IntersectionObserver' in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.15}).observe(gallery);
else {visible=true;sync();}
document.addEventListener('visibilitychange',sync);
sync();
});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
document.addEventListener('shopify:section:load',event=>setup(event.target));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuva-drop-bubbles"] && !Shopify.designMode) return;
  try {
    
if (!window.nuvaPaintNavigation) {
  window.nuvaPaintNavigation = true;
  let active = false;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-nuva-paint-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    event.preventDefault();
    if (active) return;
    active = true;
    const rect = link.querySelector('.nuva-drop-bubble__sphere').getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    const layer = document.createElement('div');
    layer.className = 'nuva-paint-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
    for (let i = 0; i < 20; i++) {
      const angle = i * Math.PI * 2 / 20;
      const distance = 90 + (i % 5) * 38;
      const size = 20 + (i % 4) * 17;
      const splat = document.createElement('div');
      splat.className = 'nuva-paint-splat';
      splat.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size + 'px';
      layer.appendChild(splat);
      splat.animate([
        { transform: 'translate(-50%,-50%) scale(0)' },
        { transform: 'translate(calc(-50% + ' + Math.cos(angle) * distance + 'px),calc(-50% + ' + Math.sin(angle) * distance + 'px)) scale(1.6)' }
      ], { duration:420, delay:i%3*18, easing:'cubic-bezier(.12,.6,.2,1)', fill:'forwards' });
    }
    const core = document.createElement('div');
    core.className = 'nuva-paint-core';
    core.style.left = x + 'px';
    core.style.top = y + 'px';
    layer.appendChild(core);
    const scale = Math.hypot(window.innerWidth,window.innerHeight) / 10;
    core.animate([{transform:'translate(-50%,-50%) scale(0)'},{transform:'translate(-50%,-50%) scale(' + scale + ')'}],{duration:540,delay:100,easing:'cubic-bezier(.35,.02,.65,1)',fill:'forwards'});
    window.setTimeout(() => { window.location.assign(link.href); },690);
  });
  window.addEventListener('pageshow', () => { active = false; document.querySelectorAll('.nuva-paint-layer').forEach(el => el.remove()); });
}

  } catch(e) { console.error(e); }
})();
})();
